import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Text } from '@blueprint/text';

export const AmenitiesList = styled('ul')(
    ({ theme: { colors, spacing, mq } }) => css`
        padding: 0;
        margin: ${spacing['spacing-3']} 0 ${spacing['spacing-2']} 0;
        ${mq.medium} {
            columns: 2;
            column-rule: 1px solid ${colors['grey-aluminium']};
            column-gap: ${spacing['48px']};
        }
        ${mq.large} {
            margin-bottom: 0;
        }
    `
);

export const StyledAmenityIcon = styled('span')(
    ({ theme: { spacing } }) => css`
        margin-right: ${spacing['8px']};
        display: inline-flex;
        align-items: center;
    `
);

export const AmenityItem = styled('li')(
    ({ theme: { spacing } }) => css`
        display: flex;
        break-inside: avoid-column;
        align-items: center;
        text-decoration: none;
        list-style-type: none;
        margin-bottom: ${spacing['8px']};
    `
);

export const AmenityDistance = styled.span(
    ({ theme: { colors, fontSizes } }) => css`
        :last-child {
            margin-left: auto;
            flex-shrink: 0;
            color: ${colors['grey-steel']};
            font-size: ${fontSizes[2]};
        }
    `
);

export const AmenityTitle = styled.span(
    ({ theme: { colors, fontSizes, spacing, type } }) => css`
        font-weight: ${type.normal};
        color: ${colors['grey-steel']};
        font-size: ${fontSizes[2]};
        hyphens: auto;
        margin-right: ${spacing['8px']};
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    `
);

export const Disclaimer = styled(Text)(
    ({ theme: { mq, spacing } }) => css`
        margin-top: ${spacing['spacing-1']};

        span {
            display: block;

            ${mq.medium} {
                display: inline;
            }
        }
    `
);
